import { makeActionCreator } from '../../config/store/utils'
import { getSuppliersAmountList, getSupplierAmountDetail } from '../../services/charts'

export const SUPPLIERSAMOUNTS = 'SUPPLIERSAMOUNTS'
export const SUPPLIERSAMOUNTS_ERROR = 'SUPPLIERSAMOUNTS_ERROR'
export const SUPPLIERSAMOUNTS_SUCCESS = 'SUPPLIERSAMOUNTS_SUCCESS'
export const SUPPLIERSAMOUNTSDETAIL_SUCCESS = 'SUPPLIERSAMOUNTSDETAIL_SUCCESS'
export const SUPPLIERSAMOUNTSDETAIL_UNLOAD = 'SUPPLIERSAMOUNTSDETAIL_UNLOAD'
export const onSuppliersAmount = makeActionCreator(SUPPLIERSAMOUNTS)
export const onSuppliersAmountError = makeActionCreator(SUPPLIERSAMOUNTS_ERROR, 'payload')
export const onSuppliersAmountSuccess = makeActionCreator(SUPPLIERSAMOUNTS_SUCCESS, 'payload')
export const onSuppliersAmountDetailSuccess = makeActionCreator(SUPPLIERSAMOUNTSDETAIL_SUCCESS, 'payload')
export const onSuppliersAmountDetailUnload = makeActionCreator(SUPPLIERSAMOUNTSDETAIL_UNLOAD, 'payload')
export const onSuppliersAmountThunk = (idEntity, year) => async dispatch => {
  dispatch(onSuppliersAmount())

  try {
    const response = await getSuppliersAmountList({ idEntity, year })

    if (response.data.success !== 'OK') {
      return dispatch(onSuppliersAmountError(response.data.errores))
    }

    const csvStructure = [
      ['Nombre proveedor', 'RUT proveedor', 'Monto transado (CLP)', 'N° de órdenes de compra'],
      ...response.data.payload?.map(item => [
        item.provider,
        item.rutProvider,
        item.annualCLPGrossAmount,
        item.annualPOnumber
      ])
    ]
    const payload = { csvStructure, chartStructure: response.data.payload }

    return dispatch(onSuppliersAmountSuccess(payload))
  } catch (error) {
    return dispatch(onSuppliersAmountError(error))
  }
}
export const onSuppliersAmountDetailThunk = (idEntity, year, dni) => async dispatch => {
  dispatch(onSuppliersAmount())

  try {
    const response = await getSupplierAmountDetail({ idEntity, year, dni })

    if (response.data.success !== 'OK') {
      return dispatch(onSuppliersAmountError(response.data.errores))
    }

    return dispatch(onSuppliersAmountDetailSuccess(response.data.payload))
  } catch (error) {
    return dispatch(onSuppliersAmountError(error))
  }
}
